import React from 'react'

import { motion } from 'framer-motion/dist/framer-motion'
import './ErrorPath.scss'

export function ErrorPath() {
	return (
		<motion.h2>
			<b>4</b>0<b>4</b>
		</motion.h2>
	)
}
